import { FC, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Image from 'next/image';

interface IGallery {
  mediaItemUrl: string;
  altText: string;
  mediaDetails: {
    height: number;
    width: number;
  };
}

interface SyncSlider {
  gallery: IGallery[];
  className?: string;
  sliderToShow?: number;
}
export const ProductGallerySlider: FC<SyncSlider> = ({ gallery }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [nav1, setNav1] = useState<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [nav2, setNav2] = useState<any>();

  return (
    <div className="mx-auto flex max-w-[310px] flex-col gap-2 md:max-h-[360px] md:max-w-[704px] md:flex-row md:gap-7 mdOnly:mx-0 lg:mx-0 lg:aspect-[1.54/1] lg:max-h-fit lg:max-w-none lg:flex-col lg:gap-3">
      <div className="px-2 md:max-w-[520px] md:px-0 md:pt-[10px] lg:max-w-none lg:px-2 lg:pt-0">
        <Slider
          asNavFor={nav2}
          fade={true}
          swipeToSlide={false}
          arrows={false}
          ref={slider1 => setNav1(slider1)}
        >
          {gallery.map((item, index) => (
            <div key={index}>
              <div className="bg-gradient-to-b from-grStart to-grEnd p-5 md:py-[14px]">
                <Image
                  src={item?.mediaItemUrl}
                  alt={item?.altText}
                  height={item?.mediaDetails.height}
                  width={item?.mediaDetails.width}
                  className="aspect-[1.54/1] object-contain object-center"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="md:max-w-[152px] lg:max-w-none">
        <Slider
          asNavFor={nav1}
          ref={slider2 => setNav2(slider2)}
          slidesToShow={gallery.length >= 3 ? 3 : gallery.length}
          swipeToSlide={true}
          focusOnSelect={true}
          vertical={false}
          verticalSwiping={false}
          arrows={false}
          responsive={[
            {
              breakpoint: 1280,
              settings: {
                vertical: true,
                verticalSwiping: true,
              },
            },
            {
              breakpoint: 768,
              settings: {
                vertical: false,
                verticalSwiping: false,
              },
            },
          ]}
        >
          {gallery.map(item => (
            <div key={item?.mediaItemUrl} className="p-2">
              <div className="cursor-pointer bg-gradient-to-b  from-grStart to-grEnd p-3 lg:py-2">
                <Image
                  src={item?.mediaItemUrl}
                  alt={item?.altText}
                  height={item?.mediaDetails.height}
                  width={item?.mediaDetails.width}
                  className="aspect-[1.54/1] object-contain object-center lg:aspect-[1.43/1] lg:max-h-[110px]"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
